import { OAuthProvider, type OAuthProviderConfig } from "./OAuthProvider";
import type { User } from "../types";

export interface Auth0ProviderConfig extends Omit<OAuthProviderConfig, "endpoints"> {
  /** e.g. "your-tenant.us.auth0.com" (no protocol) */
  domain: string;
}

/** Auth0-flavored OIDC. Endpoints are derived from the tenant `domain`. */
export class Auth0Provider extends OAuthProvider {
  constructor(config: Auth0ProviderConfig) {
    const root = `https://${config.domain}`;
    super({
      ...config,
      endpoints: {
        authorize: `${root}/authorize`,
        token: `${root}/oauth/token`,
        userInfo: `${root}/userinfo`,
        endSession: `${root}/v2/logout`,
      },
    });
  }

  protected normalizeUser(raw: Record<string, unknown>): User {
    const base = super.normalizeUser(raw);
    return {
      ...base,
      avatarUrl: typeof raw.picture === "string" ? raw.picture : base.avatarUrl,
      displayName: typeof raw.nickname === "string" ? raw.nickname : base.displayName,
    };
  }
}
